

    const   body = document.querySelector('body'),
            siteHeader = document.querySelector('.site-header'),
            menuArea = document.querySelector('.primary-nav'),
            overlay = document.querySelector('.navbar__overlay'),
            toggle = document.querySelector('.menu-toggle'),
            logo = document.querySelector('.navbar__logo-container');
    /**
     * Menu toggle handler
     */
    const toggles = document.querySelectorAll('.toggle');
    [...toggles].forEach(toggle => {
        toggle.addEventListener('click', e => {
            e.preventDefault();
            const id = toggle.getAttribute('aria-controls');
            const target = document.querySelector(`#${id}`);
            target.classList.toggle('is-visible');
            target.setAttribute('aria-expanded', target.classList.contains('is-visible'));
            setTimeout(()=>{
                target.focus(); // wait for visibility css
            },500);
            logo.setAttribute('tabindex', ( target.classList.contains('is-visible') ? '-1' : '' ) );
            body.classList.toggle('no-scroll');
            overlay.classList.toggle('active');
            const toggles = document.querySelectorAll(`[aria-controls="${id}"]`);
            toggles.forEach(toggle => {
                toggle.setAttribute('aria-expanded', target.classList.contains('is-visible'));
            });
        });
    });

    /**
     * Closes any open sidebar on ESC key
     */
    document.addEventListener('keyup', e => {
        if (e.key == "Esc" || e.keyCode == 27) {
            closeOpened();
        }
    });

    /**
     * Closes sidebar when tapped outside.
     */
    overlay.addEventListener('click', e => {
        closeOpened();
    });

    // Close the menu when the last focusable element is blurred
    const focusables = menuArea.querySelectorAll('a', 'select', 'input', 'button', 'textarea');
    const lastFocusable = focusables[focusables.length - 1];
    lastFocusable.onblur = e => {
        closeOpened();
    };

    function closeOpened() {
        const opened = document.querySelectorAll('.is-visible');
        [...opened].forEach(open => {
            open.classList.remove('is-visible');
        });
        [...toggles].forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
        });
        logo.setAttribute('tabindex', '' );
        document.querySelectorAll('.menu-toggle').forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
        });
        overlay.classList.remove('active');
        body.classList.remove('no-scroll');
    }

    /**
     * Open/Close sub menus
     */
    const subMenuToggles = document.querySelectorAll( '.menu-item--button' );
    subMenuToggles.forEach( function( buttonToggle ) {
        buttonToggle.addEventListener('click', e => {
            if ( 765 > window.innerWidth ) {
                e.preventDefault();
            }
            bauschlombExpandSubMenu( e.target );
        } );
    } );
    const subMenuTogglesClose = document.querySelectorAll( '.menu-item--button-close' );
    subMenuTogglesClose.forEach( function( buttonToggleClose ) {
        buttonToggleClose.addEventListener('click', e => {
            e.preventDefault();
            const control = document.getElementById( e.target.getAttribute( 'aria-controls' ) ),
                  targets = document.querySelectorAll( '[aria-controls="' + e.target.getAttribute( 'aria-controls' ) + '"]' );
                  console.log('[aria-controls="' + control + '"]');
            control.setAttribute( 'aria-expanded', 'false' );
            targets.forEach( function( target ) {
                target.setAttribute( 'aria-expanded', 'false' );
            } );
        } );
    } );

    /**
     * Toggle an attribute's value
     *
     * @param {Element} el - The element.
     * @param {boolean} withListeners - Whether we want to add/remove listeners or not.
     * @since Twenty Twenty-One 1.0
     */
    function bauschlombToggleAriaExpanded( el, withListeners ) {
        const control = document.getElementById( el.getAttribute( 'aria-controls' ) );

        if ( 'true' !== el.getAttribute( 'aria-expanded' ) ) {
            el.setAttribute( 'aria-expanded', 'true' );
            control.setAttribute( 'aria-expanded', 'true' );
            if ( withListeners ) {
                document.addEventListener( 'click', bauschlombCollapseMenuOnClickOutside );
            }
        } else {
            el.setAttribute( 'aria-expanded', 'false' );
            control.setAttribute( 'aria-expanded', 'false' );
            if ( withListeners ) {
                document.removeEventListener( 'click', bauschlombCollapseMenuOnClickOutside );
            }
        }
    }

    function bauschlombCollapseMenuOnClickOutside( event ) {
        if ( ! document.getElementById( 'site-navigation' ).contains( event.target ) ) {
            document.getElementById( 'site-navigation' ).querySelectorAll( '.menu-item--button' ).forEach( function( button ) {
                button.setAttribute( 'aria-expanded', 'false' );
            } );
        }
    }

    /**
     * Handle clicks on submenu toggles.
     *
     * @param {Element} el - The element.
     */
    function bauschlombExpandSubMenu( el ) { // jshint ignore:line
        // Close other expanded items.        
        el.closest( 'nav' ).querySelectorAll( '.menu-item--button' ).forEach( function( link ) {
            if ( link !== el ) {
                link.setAttribute( 'aria-expanded', 'false' );
            }
        } );

        // Toggle aria-expanded on the button.
        bauschlombToggleAriaExpanded( el, true );
    }

    document.querySelectorAll( '.primary-nav .menu-item-has-children > a' ).forEach( function( firstSubMenuLink ) {

        firstSubMenuLink.addEventListener('mouseover', e => {

            e.target.closest( 'nav' ).querySelectorAll( 'ul li ul li .menu-link--active' ).forEach( function( link ) {
                //const parentLink = 
                if ( link !== e.target ) {
                    link.classList.remove( 'menu-link--active' );
                }
            } );

            if ( e.target.nextElementSibling.querySelector( '.menu-item-has-children:nth-child(2) > a' ) ) {
                e.target.nextElementSibling.querySelector( '.menu-item-has-children:nth-child(2) > a' ).classList.add( 'menu-link--active' );
            }
            
        } );

    } );


    var lastScrollTop = 0;

    function bauschlombFixHeader() {
        var scroll = window.pageYOffset || document.documentElement.scrollTop,
        siteHeaderHeight = siteHeader.clientHeight;

        if (scroll >= 5) {
            siteHeader.classList.add( 'site-header--fixed' );
            body.style.paddingTop = siteHeaderHeight + 'px'; // fix jumping effect
        } else {
            siteHeader.classList.remove( 'site-header--fixed' );
            body.style.paddingTop = '0px'; // fix jumping effect
        }

        if ( scroll <= lastScrollTop ) {
            siteHeader.classList.add( 'site-header--visible' );
        } else {
            siteHeader.classList.remove( 'site-header--visible' );
        }

        lastScrollTop = scroll <= 0 ? 0 : scroll;
    }

    window.onscroll = bauschlombFixHeader;